import {
  InMemoryCache,
  IntrospectionFragmentMatcher
} from "apollo-cache-inmemory";
import VueApollo from "vue-apollo";
import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import Cookies from "universal-cookie";
import Vue from "vue";
import vueCustomElement from "vue-custom-element";
import VueI18n from "vue-i18n";
import introspectionQueryResultData from "../apollo/fragmentTypes.json";
// Font Awesome
import { faTimes, faChevronDown } from "@fortawesome/pro-light-svg-icons";
import { config, library } from "@fortawesome/fontawesome-svg-core";

import {
  ValidationProvider,
  ValidationObserver,
  extend,
  configure
} from "vee-validate";
import { email, required } from "vee-validate/dist/rules.umd";

import "../src/styles/index.css";

import messages from "../lang/config";

// Font Awesome
config.autoAddCss = false;
library.add(faTimes, faChevronDown);

// Components + Widgets
import * as components from "@holidayguru/holidayguru-components";
import HgRaffle from "../src/widgets/Raffle.vue";

Vue.config.productionTip = false;

let locale = "de";

if (window.location.host.includes(".at")) {
  locale = "at";
} else if (window.location.host.includes(".ch")) {
  locale = "ch";
} else if (window.location.host.includes(".es")) {
  locale = "es";
} else if (window.location.host.includes(".nl")) {
  locale = "nl";
}

// Validation
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

extend("required", required);
extend("email", email);

extend("password", {
  validate: value => {
    if (value.length < 6) return false;
    return true;
  }
});

extend("passwordConfirm", {
  validate: (value, { other }) => {
    console.log("Confirm password", value, other);
    if (!other) return true;
    return value === other;
  },

  params: [{ name: "other", isTarget: true }]
});

configure({
  defaultMessage: (field, values) => {
    console.log("Field", field, values);
    values._field_ = i18n.t(`${field}`);
    return i18n.t(`validation.${values._rule_}`, values);
  }
});

/**
 * Apollo Config
 */
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

const cookies = new Cookies();
const authToken = cookies.get("apollo-token");
window.hasAuthToken = authToken ? true : false;

// Apollo HTTP-Link
// uri to final graphql
const httpLink = createHttpLink({
  uri: "https://graphql.holidayguru.de",
  headers: {
    "x-locale": locale,
    authorization: authToken ? `Bearer ${authToken}` : null
  }
});

// Cache
const cache = new InMemoryCache({ fragmentMatcher });
// Apollo Client
const apolloClient = new ApolloClient({
  link: httpLink,
  cache
});

// Apollo Provider
const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

// Vue.use(VLazyImagePlugin);
Vue.use(VueApollo);
Vue.apolloProvider = apolloProvider;

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: locale,
  messages: messages
});

HgRaffle.apolloProvider = apolloProvider;
// HgSystemNotification.apolloProvider = apolloProvider;
HgRaffle.i18n = i18n;

Object.keys(components).forEach(componentName => {
  Vue.component(componentName, components[componentName]);
});

// Use Plugins
Vue.use(vueCustomElement);

// Define Element
Vue.customElement("hg-raffle-widget", HgRaffle);
// Vue.customElement("hg-system-notification-widget", HgSystemNotification);

setTimeout(() => {
  if (document) {
    document.querySelector("body").style.fontSize = "16px";
  }
}, 300);
